var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoCamIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6307 1.77269C13.3745 1.64252 12.8371 1.50643 12.106 1.99162L10.3589 2.60699C10.2902 0.766799 9.44659 0.0449219 7.39702 0.0449219H3.64781C1.51076 0.0449219 0.679688 0.831886 0.679688 2.85551V7.58913C0.679688 8.95005 1.46077 10.3997 3.64781 10.3997H7.39702C9.44659 10.3997 10.2902 9.67784 10.3589 7.83765L12.106 8.45302C12.4934 8.71336 12.8309 8.7962 13.0996 8.7962C13.3308 8.7962 13.512 8.73112 13.6307 8.67195C13.8869 8.54769 14.3181 8.21042 14.3181 7.36428V3.08036C14.3181 2.23422 13.8869 1.89695 13.6307 1.77269ZM6.45972 4.85546C5.81611 4.85546 6.5783 5.66999 6.5783 5.05462C6.5783 4.43924 5.65736 5.7353 6.30098 5.7353C6.94459 5.7353 6.09929 4.43924 6.09929 5.05462C6.09929 5.66999 7.10333 4.85546 6.45972 4.85546Z",
    fill: "#F9FAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCamIcon);
export default __webpack_public_path__ + "static/media/video_cam_icon.1a8583f630eb8735baf9bc4f57c46671.svg";
export { ForwardRef as ReactComponent };